'use strict';
jQuery($ => {
    $(document).ready(() => {
        const swiperSettings = {
            spaceBetween: 24,
            // autoHeight: true,
            loop: true,

            speed: 1000,
            autoplay: {
                delay: 5000,
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        }
        const swiper = new Swiper('.gecko-builder-testimonial-slider__wrapper .swiper-container', swiperSettings);
    });
});
